<template>
    <div class="health-monitor-page">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator="/" class="breadcrumb" style="margin-bottom: 15px;">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>健康监护</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 筛选区域 -->
        <el-card class="general-card" shadow="hover" style="margin-bottom: 20px;">
            <el-form :inline="true" :model="formModel" class="filter-form">
                <!-- 老人姓名 -->
                <el-form-item label="老人姓名">
                    <el-input v-model="formModel.oldName" placeholder="请输入老人姓名" style="width: 140px;"></el-input>
                </el-form-item>

                <!-- 状态 -->
                <el-form-item label="状态">
                    <el-select v-model="formModel.status" placeholder="请选择状态" clearable style="width: 140px;">
                        <el-option label="异常" value="异常"></el-option>
                        <el-option label="关注" value="关注"></el-option>
                        <el-option label="正常" value="正常"></el-option>
                    </el-select>
                </el-form-item>

                <!-- 刷新按钮 -->
                <el-form-item>
                    <el-button type="primary" icon="el-icon-refresh" @click="refreshData">
                        刷新数据
                    </el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 卡片列表区域 -->
        <div v-loading="loading" element-loading-text="加载中..." class="card-list">
            <el-card v-for="(item, index) in healthData" :key="index" shadow="hover" class="custom-card">
                <!-- 卡片头部 -->
                <div slot="header" class="card-header">
                    <div class="header-left">
                        <el-avatar :style="{ backgroundColor: '#14C9C9', marginRight: '10px' }">
                            <i class="el-icon-user" v-if="item.sex === 0" style="font-size: 30px;"></i>
                            <i class="el-icon-woman" v-else style="font-size: 30px;"></i>
                        </el-avatar>
                        <div class="header-info">
                            <div class="old-name">
                                {{ item.oldName }}
                                <span class="id-card">{{ item.idCard }}</span>
                            </div>
                            <div class="old-age">{{ item.age }}岁</div>
                        </div>
                    </div>
                    <el-tag :type="getStatusType(item.status)" class="status-tag">
                        {{ item.status }}
                    </el-tag>
                </div>

                <!-- 卡片内容 -->
                <div class="card-content">
                    <el-row :gutter="10">
                        <!-- 心率 -->
                        <el-col :span="8" class="data-item">
                            <div class="data-title">心率</div>
                            <div class="data-value" :style="{ color: getStatusColorByItem(item.heartRateItem) }">
                                {{ item.heartRate }}
                                <span class="data-unit">次/分</span>
                                <i class="el-icon-arrow-up" v-if="item.status === '异常'"></i>
                            </div>
                        </el-col>

                        <!-- 血压 -->
                        <el-col :span="8" class="data-item">
                            <div class="data-title">血压</div>
                            <div class="data-value" :style="{ color: getStatusColorByItem(item.bloodPressItem) }">
                                {{ item.bloodPress }}
                                <i class="el-icon-arrow-up" v-if="item.status === '异常'"></i>
                            </div>
                        </el-col>

                        <!-- 血氧/呼吸 -->
                        <el-col :span="8" class="data-item">
                            <div class="data-title">{{ item.oxygen !== 0 ? '血氧' : '呼吸' }}</div>
                            <div class="data-value"
                                :style="{ color: getStatusColorByItem(item.oxygen !== 0 ? item.oxygenItem : item.breathItem) }">
                                {{ item.oxygen !== 0 ? item.oxygen : item.breath }}
                                <span class="data-unit">{{ item.oxygen !== 0 ? '%' : '次/分' }}</span>
                                <i class="el-icon-arrow-up" v-if="item.status === '异常'"></i>
                            </div>
                        </el-col>
                    </el-row>

                    <!-- 提示信息 -->
                    <el-alert :message="item.tip" :type="getStatusType(item.status)" :show-icon="false"
                        class="alert-tip"></el-alert>
                </div>

                <!-- 卡片底部 -->
                <!-- <div class="card-footer">
                    <el-button type="text" class="detail-btn" @click="handleViewDetail(item)">
                        查看详情 <i class="el-icon-arrow-right"></i>
                    </el-button>
                </div> -->
            </el-card>
        </div>

        <!-- 分页组件 -->
        <el-pagination @current-change="handlePageChange" :current-page="pageNum" :page-size="pageSize" :total="total"
            layout="total, prev, pager, next, jumper" align="center" class="pagination"></el-pagination>
    </div>
</template>

<script>
export default {
    name: 'HealthMonitor',
    data() {
        return {
            // 筛选表单
            formModel: {
                oldName: '',
                status: '',
                street: '',
                community: '',
                pageNum: 1
            },
            // 分页相关
            pageNum: 1,
            pageSize: 12,
            total: 0,
            loading: true,
            // 数据列表
            healthData: [],
            // 乡镇选项
            streetOptions: [
                '清泉镇', '巴河镇', '竹瓦镇', '汪岗镇', '团陂镇',
                '关口镇', '白莲镇', '蔡河镇', '洗马镇', '丁司垱镇',
                '散花镇', '兰溪镇', '经济开发区', '绿杨乡',
                '策湖国家湿地公园管理处', '三角山旅游度假区管理委员会'
            ],
            // 社区列表
            communityListVal: [],
            areaOptions: [],
            // 角色标识（从缓存获取）
            role: '',
            // 定时刷新计时器
            interval: null
        };
    },
    methods: {
        // 获取区域数据
        fetchArea() {
            this.$postJson('mdc/dictArea/getTree', {}).then(res => {
                const street = window.localStorage.getItem('street');
                const community = window.localStorage.getItem('community');

                // 回显缓存的筛选条件
                if (street) this.formModel.street = street;
                if (community) this.formModel.community = community;

                this.areaOptions = res;
                this.communityListVal = [];

                if (res.length > 0) {
                    res[0].children.forEach(item => {
                        item.children.forEach(item2 => {
                            this.communityListVal.push(item2.dictValue);
                        });
                        // 角色为街道时，只显示对应社区
                        if (this.role === 'street' && street === item.dictValue) {
                            item.children.forEach(item2 => {
                                this.communityListVal.push(item2.dictValue);
                            });
                        }
                    });
                }
            });
        },

        // 切换乡镇加载对应社区
        changeStreet(value) {
            const communityList = [];
            this.areaOptions[0].children.forEach(item => {
                if (item.dictValue === value) {
                    item.children.forEach(item2 => {
                        communityList.push(item2.dictValue);
                    });
                }
            });
            this.communityListVal = communityList;
            this.formModel.community = ''; // 重置社区选择
        },

        // 获取健康数据列表
        fetchData() {
            const street = window.localStorage.getItem('street');
            const community = window.localStorage.getItem('community');

            // 补全缓存的筛选条件
            if (street) this.formModel.street = street;
            if (community) this.formModel.community = community;

            const params = {
                pageNum: this.formModel.pageNum,
                oldmanName: this.formModel.oldName,
                street: this.formModel.street,
                community: this.formModel.community,
                status: this.formModel.status,
                pageSize: this.pageSize
            };

            this.loading = true;
            this.$postJson('dmc/healthManagement/queryAllHealthSurveillance', params).then(res => {
                this.loading = false;
                console.log(res);
                if (res.result.list) {
                    this.healthData = res.result.list.map(item => {
                        // 提取各项健康指标
                        const heartRateItem = item.healthSurveillanceList.find(i => i.category === 'heart_rate');
                        const bloodPressItem = item.healthSurveillanceList.find(i => i.category === 'blood_press');
                        const oxygenItem = item.healthSurveillanceList.find(i => i.category === 'oxygen');
                        const breathItem = item.healthSurveillanceList.find(i => i.category === 'breath');

                        // 判断状态
                        const hasAbnormal = item.healthSurveillanceList.some(i => i.riskLevel === 2);
                        const hasAttention = item.healthSurveillanceList.some(i => i.riskLevel === 3);
                        let status = '正常';
                        let tip = '各项指标正常';

                        if (hasAbnormal) {
                            status = '关注';
                            tip = '部分指标需关注，建议定期监测';
                        } else if (hasAttention) {
                            status = '异常';
                            tip = '存在异常指标，建议及时干预';
                        }

                        return {
                            oldName: item.oldName,
                            age: item.age,
                            idCard: item.idCard,
                            sex: item.sex || 0,
                            status,
                            tip,
                            heartRateItem,
                            bloodPressItem,
                            oxygenItem,
                            breathItem,
                            heartRate: heartRateItem ? Number(heartRateItem.value) : 0,
                            bloodPress: bloodPressItem ? bloodPressItem.value.replace('mmHg', '') : '-',
                            oxygen: oxygenItem ? Number(oxygenItem.value) : 0,
                            breath: breathItem ? Number(breathItem.value) : 0
                        };
                    });
                    this.total = Number(res.result.total);
                }
            }).catch(error => {
                this.loading = false;
                this.$message.error('数据获取失败，请重试');
                console.error(error);
            });
        },

        // 定时刷新数据
        fetchNewData() {
            const street = window.localStorage.getItem('street');
            const community = window.localStorage.getItem('community');

            if (street) this.formModel.street = street;
            if (community) this.formModel.community = community;

            const params = {
                pageNum: this.formModel.pageNum,
                oldmanName: this.formModel.oldName,
                street: this.formModel.street,
                community: this.formModel.community,
                status: this.formModel.status,
                pageSize: this.pageSize
            };

            this.$postJson('dmc/healthManagement/queryAllHealthSurveillance', params).then(res => {
                if (res.list) {
                    this.healthData = res.list.map(item => {
                        const heartRateItem = item.healthSurveillanceList.find(i => i.category === 'heart_rate');
                        const bloodPressItem = item.healthSurveillanceList.find(i => i.category === 'blood_press');
                        const oxygenItem = item.healthSurveillanceList.find(i => i.category === 'oxygen');
                        const breathItem = item.healthSurveillanceList.find(i => i.category === 'breath');

                        const hasAbnormal = item.healthSurveillanceList.some(i => i.riskLevel === 2);
                        const hasAttention = item.healthSurveillanceList.some(i => i.riskLevel === 3);
                        let status = '正常';
                        let tip = '各项指标正常';

                        if (hasAbnormal) {
                            status = '关注';
                            tip = '部分指标需关注，建议定期监测';
                        } else if (hasAttention) {
                            status = '异常';
                            tip = '存在异常指标，建议及时干预';
                        }

                        return {
                            oldName: item.oldName,
                            age: item.age,
                            idCard: item.idCard,
                            sex: item.sex || 0,
                            status,
                            tip,
                            heartRateItem,
                            bloodPressItem,
                            oxygenItem,
                            breathItem,
                            heartRate: heartRateItem ? Number(heartRateItem.value) : 0,
                            bloodPress: bloodPressItem ? bloodPressItem.value.replace('mmHg', '') : '-',
                            oxygen: oxygenItem ? Number(oxygenItem.value) : 0,
                            breath: breathItem ? Number(breathItem.value) : 0
                        };
                    });
                    this.total = Number(res.total);
                }
            });
        },

        // 刷新数据
        refreshData() {
            this.formModel.pageNum = 1;
            this.fetchData();
        },

        // 分页切换
        handlePageChange(val) {
            this.formModel.pageNum = val;
            this.fetchData();
        },

        // 查看详情
        handleViewDetail(item) {
            // this.$router.push({
            //     name: 'healthMonitorDetail',
            //     query: {
            //         oldId: item.oldId,
            //         oldIdCard: item.idCard,
            //         oldName: item.oldName,
            //         age: item.age
            //     }
            // });
        },

        // 获取状态标签类型
        getStatusType(status) {
            if (status === '异常') return 'danger';
            if (status === '关注') return 'warning';
            return 'success';
        },

        // 获取状态颜色
        getStatusColorByItem(item) {
            if (!item) return 'gray';
            if (item.riskLevel === 3) return 'red';
            if (item.riskLevel === 2) return 'orange';
            return 'green';
        }
    },
    mounted() {
        // 获取角色（实际项目中从缓存获取）
        this.role = window.localStorage.getItem('role') || '';
        // 加载区域数据
        // 加载健康数据
        this.fetchData();
        // 定时3分钟刷新
        this.interval = setInterval(() => {
            this.fetchNewData();
        }, 1000 * 60 * 3);
    },
    beforeDestroy() {
        // 清除定时器
        if (this.interval) {
            clearInterval(this.interval);
        }
    }
};
</script>

<style scoped lang="scss">
.health-monitor-page {
    padding: 10px;

    .breadcrumb {
        font-size: 14px;
        color: #666;
    }

    .general-card {
        background-color: #fff;
        border-radius: 8px;
    }

    .filter-form {
        padding: 10px 0;
    }

    .card-list {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        margin-bottom: 20px;
    }

    .custom-card {
        width: calc(24% - 5px);
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        height: 235px;
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 15px;
        border-bottom: 1px solid #f5f5f5;

        .header-left {
            display: flex;
            align-items: center;
        }

        .header-info {
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        .old-name {
            font-size: 15px;
            font-weight: 500;
            color: #333;

            .id-card {
                font-size: 12px;
                color: #666;
                margin-left: 8px;
            }
        }

        .old-age {
            font-size: 14px;
            color: #666;
            margin-top: 2px;
        }

        .status-tag {
            font-size: 12px;
            padding: 2px 8px;
        }
    }

    .card-content {
        flex: 1;
        padding: 15px;
        display: flex;
        flex-direction: column;

        .data-item {
            text-align: center;

            .data-title {
                font-size: 14px;
                color: #666;
                margin-bottom: 5px;
            }

            .data-value {
                font-size: 18px;
                font-weight: 500;
                display: flex;
                align-items: center;
                justify-content: center;

                .data-unit {
                    font-size: 12px;
                    color: #666;
                    margin-left: 4px;
                }

                .el-icon-arrow-up {
                    color: red;
                    margin-left: 4px;
                    font-size: 14px;
                }
            }
        }

        .alert-tip {
            margin-top: 15px;
            padding: 5px 10px;
            font-size: 13px;
        }
    }

    .card-footer {
        padding: 10px 15px;
        border-top: 1px solid #f5f5f5;
        text-align: right;

        .detail-btn {
            color: #1890ff;
            font-size: 14px;
            padding: 0;

            .el-icon-arrow-right {
                font-size: 12px;
                margin-left: 4px;
            }
        }
    }

    .pagination {
        padding: 10px 0;
        background-color: #fff;
        border-radius: 8px;
    }
}

// 适配不同屏幕宽度@media screen and (max-width: 1200px) {.custom-card {width: calc (33.33% - 12px);}}
@media screen and (max-width: 992px) {
    .custom-card {
        width: calc(50% - 12px);
    }
}

@media screen and (max-width: 768px) {
    .custom-card {
        width: 100%;
    }

    .filter-form {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        .el-form-item {
            margin-bottom: 10px;
        }
    }
}
</style>